<div class="news-forum">
  <h2 class="news-forum__title">
    <i class="fa-solid fa-newspaper" aria-hidden="true"></i>
    News
  </h2>
  <div class="news-forum__content mb-3">
    <button class="news-forum__add-button" *ngIf="roleService?.roles?.userType.includes('ADMIN')"
      (click)="openModalNewsAdd()">
      <i class="fa-solid fa-plus" aria-hidden="true"></i>
      Add News
    </button>
  </div>
  <ng-container *ngFor="let item of newsForum">
    <div class="news-card p-2 mb-1" [routerLink]="['/news', item.slug]">
      <div class="news-card__image">
        <img loading="lazy" class="latest-news-img" [src]="imgUrl + item.image" alt="{{ item.title }}"
          (error)="commonService.handleError($event)" />
      </div>
      <div class="news-card__content">
        <h3 class="news-card__title d-md-block d-none" style="height: 2.15rem; overflow: hidden;">{{
          formatText(item.title) }}</h3>
        <h3 class="news-card__title d-md-none d-block">{{ shortText(formatText(item.title), 50) }}</h3>
        <p class="news-card__date">
          <i class="fa-solid fa-calendar"></i> {{ convertDate(item.created) }}
        </p>
        <p class="news-card__date">
          <i class="fa-solid fa-user"></i> {{ item.author }}
        </p>
      </div>
    </div>
    <button class="btn btn-sm btn-danger mb-3 w-100" *ngIf="roleService?.roles?.userType.includes('ADMIN')"
      (click)="removeNewsFromForum(item.id)">
      <i class="fa-solid fa-trash"></i> Delete
    </button>
  </ng-container>
  <div *ngIf="newsForum.length < 1" class="no-news-message">
    <p>No news available at the moment.</p>
  </div>
</div>


<ng-template #modalNewsAdd let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Add News to Forum</h2>

    <div class="form-group">
      <input type="text" class="form-control" placeholder="Search..." id="search" [(ngModel)]="search"
        (ngModelChange)="initNews(search)">
    </div>
    <div class="row px-3">
      <div class="col-md-3" *ngFor="let item of news">
        <div class="news-card mb-3 p-2" [class.active]="selectedNews.includes(item.id)" (click)="selectNews(item)">
          <div class="news-card__image">
            <img loading="lazy" class="latest-news-img" [src]="imgUrl + item.image" alt="{{ item.title }}"
              (error)="commonService.handleError($event)" />
          </div>
          <div class="news-card__content">
            <h3 class="news-card__title d-md-block d-none" style="height: 2.15rem; overflow: hidden;">{{
              formatText(item.title) }}</h3>
            <h3 class="news-card__title d-md-none d-block">{{ shortText(formatText(item.title), 50) }}</h3>
            <p class="news-card__date">
              <i class="fa-solid fa-calendar"></i> {{ convertDate(item.created) }}
            </p>
            <p class="news-card__date">
              <i class="fa-solid fa-user"></i> {{ item.author }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <button class="ml-auto d-flex my-button-3" (click)="submitNewsToForum()"><i class="fa-solid fa-save"></i>
      Submit</button>
  </div>
</ng-template>